<template>
    <div>
        <div class="main-content f-left">
            <Form class="fullMob" @submit="submitQuestion()" style=" min-height: 500px; justify-content: center; align-items: center; max-width: 65%; margin: 0 auto;">
                <div class="content-holder">
                    <div class="row-sec">
                        <div class="form-holder wow fadeInLeft">
                            <!-- <h2>AAAFx Global Financial Questionnaire</h2>
                            <p>Financial Questionnaire for users of AAAFx Global</p> -->
                            <ul class="clearfix onclickList">
                                <h4 class="ltWer">{{$t("questions.financial_details")}}</h4>
                                <li class="">
                                    <div class="ltWer position-relative">
                                        <label for="">{{$t("questions.sub_heading_one")}}<span class="red">*</span></label>
                                        <Field class="form-control" as="select" name="Annual Income" v-model="form.annual_income" rules="required">
                                            <option value="" disabled>{{$t("questions.select_annual_income")}}</option>
                                            <option v-for="val,key in incomeList" :value="parseInt(key)" :key="key">{{val}}</option>
                                        </Field>
                                        <ErrorMessage name="Annual Income" />
                                    </div>
                                    <div class="ltWer position-relative">
                                        <label for="">{{$t("questions.sub_heading_two")}}<span class="red">*</span></label>
                                        <p>{{$t("questions.sub_heading_two_desc")}}</p>
                                        <Field class="form-control" as="select" name="Net Worth" rules="required" v-model="form.net_worth">
                                            <option value="" disabled>{{$t("questions.select_net_worth")}}</option>
                                            <option v-for="val,key in netWorthList" :value="parseInt(key)" :key="key">{{val}}</option>
                                        </Field>
                                        <ErrorMessage name="Net Worth" />
                                    </div>
                                    <div class="ltWer position-relative">
                                        <label for="">{{$t("questions.sub_heading_three")}} <span class="red">*</span></label>
                                        <Field class="form-control" as="select" name="Occupation" v-model="form.occupation" rules="required">
                                            <option value="" disabled>{{$t("questions.select_occupation")}}</option>
                                            <option v-for="val,key in occupationList" :value="parseInt(key)" :key="key">{{val}}</option>
                                        </Field>
                                        <ErrorMessage name="Occupation" />
                                    </div>
                                    <div class="ltWer position-relative" v-if="form.occupation == '34'">
                                        <label for="">{{$t("questions.sub_heading_four")}}<span class="red">*</span></label>
                                        <Field class="form-control" name="Other Occupation" type="text" v-model="form.other_occupation" maxlength="150" rules="required|max:150" />
                                        <ErrorMessage name="Other Occupation" />
                                    </div>
                                </li>
                                <li class="">
                                    <label for="">{{$t("questions.sub_heading_five")}}<span class="red">*</span></label>
                                    <div class="form-check d-flex flex-wrap">
                                        <label class="customCheckBox half-width f-left" v-for="val,key in sources_fund_list" :key="key">
                                            <p :for="'sources_fund'+key">{{val}}</p>
                                            <input type="radio" name="Sources of Funds" :id="'sources_fund'+key" :value="key" v-model="form.sources_fund" rules="required">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <ErrorMessage name="Sources of Funds" />
                                </li>
                                <li class="" v-if="form.sources_fund == '6'">
                                    <label for="">{{$t("questions.sub_heading_six")}}<span class="red">*</span></label>
                                    <Field class="form-control" name="Other Sources of Funds" type="text" v-model="form.other_sources_of_funds" maxlength="150" rules="required|max:150" />
                                    <ErrorMessage name="Other Sources of Funds" />
                                </li>
                                <li class="">
                                    <div class="ltWer position-relative">
                                        <label for="">{{$t("questions.sub_heading_seven")}}<span class="red">*</span></label>
                                        <div class="radio t-center" v-for="val,key in yesNo" :key="key">
                                            <Field type="radio" name="FATCA" :id="'FATCA-'+val" :value="parseInt(key)" v-model="form.isFATCA" rules="required" @change="isTin = ''" checked="form.isFATCA == key" :disabled="isdisabled"/>
                                            <span :for="'FATCA-'+val">{{val}}</span>
                                        </div>
                                        <ErrorMessage name="FATCA"/>
                                    </div>
                                </li>
                                <li class="" v-if="form.isFATCA == '0'"> <!-- if FATCA == no -->
                                    <label for="">{{$t("questions.sub_heading_eight")}}<span class="red">*</span></label>
                                    <Field class="form-control" as="select" name="Tax Residence" v-model="form.tax_residence" rules="required">
                                        <option value="" disabled>{{$t("questions.select_residence_country")}}</option>
                                        <option v-for="country in store.countries" :value="country.iso2" :key="country.iso2"> {{ country.name }} </option>
                                    </Field>
                                    <ErrorMessage name="Tax Residence" />
                                </li>
                                <li class="" v-if="form.isFATCA == '0'"> <!-- if FATCA == no -->
                                    <label for="">{{$t("questions.sub_heading_nine")}}<span class="red">*</span></label>
                                    <div class="radio t-center" v-for="val,key in yesNo" :key="key">
                                      <Field type="radio" name="IS TIN" :id="'TIN-Number-'+val" :value="parseInt(key)" v-model="form.isTin" rules="required"/>
                                      <span :for="'TIN-Number-'+val">{{val}}</span>
                                    </div>
                                    <ErrorMessage name="IS TIN"/>
                                </li>
                                <li class="" v-if="form.isTin == '1' && form.isFATCA == '0'"> <!-- if TIN Number ?   == yes -->
                                    <label for="">{{$t("questions.sub_heading_ten")}}<span class="red">*</span></label>
                                    <Field class="form-control" name="TIN Number" type="text" v-model="form.tin_no" maxlength="50" rules="required|max:50" />
                                    <ErrorMessage name="TIN Number" />
                                </li>
                                <li class="" v-if="form.isTin == '0' && form.isFATCA == '0'"> <!-- if TIN Number ? == no -->
                                    <label for="">{{$t("questions.sub_heading_eleven")}}<span class="red">*</span></label>
                                    <Field class="form-control" as="select" name="No Tin Reasons" v-model="form.no_tin_reason" rules="required">
                                        <option value="" disabled>{{$t("questions.select_reasons")}}</option>
                                        <option v-for="val,key in noTinReasons" :value="parseInt(key)" :key="key">{{val}}</option>
                                    </Field>
                                    <ErrorMessage name="No Tin Reasons" />
                                </li>
                                <li class="" v-if="form.isTin == '0' && form.isFATCA == '0'">
                                    <label for="">{{$t("questions.enter_reason")}}<span class="red">*</span></label>
                                    <Field class="form-control" name="Reason" type="text" v-model="form.reason" maxlength="150" rules="required|max:150" />
                                    <ErrorMessage name="Reason" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="btn-holder t-center"><button type="submit" class="btn btn-yellow popup-link-holder">{{$t("questions.submit")}}</button></div>
            </Form>
            <div class="loaderOverlayFull" v-if="showFatca">
                <div class="loaderContent">
                    <div style="margin-bottom: 20px;">
                        <h4>{{$t("questions.dear")}} {{store.user.profile.firstname}},</h4>
                        <p>{{$t("questions.message_one")}}</p>
                        <p>{{$t("questions.message_two")}}</p>
                        <p>{{$t("questions.message_three")}}</p>
                        <p>{{$t("questions.message_four")}}</p>
                        <p>{{$t("questions.message_five")}}</p>
                    </div>
                    <button type="button" @click="showFatca = false" class="btn btn-blue">{{$t("questions.close")}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useMainStore } from "@/store";
    import { Form, Field, ErrorMessage } from "vee-validate";

    export default {
        setup() {
            const store = useMainStore();
            return { store };
        },
        props:['changeStep'],
        data() {
            return {
                form: {
                    annual_income: "",
                    net_worth: "",
                    sources_fund: '',
                    other_occupation: '',
                    occupation: "",
                    other_sources_of_funds: "",
                    isFATCA: '',
                    tax_residence: '',
                    isTin: '',
                    tin_no: '',
                    no_tin_reason: '',
                    reason: '',
                },
                showFatca:false,
                incomeList:{
                    '1':'0 - $10,000',
                    '2':'$10,000 - $50,000',
                    '3':'$50,000 - $100,000',
                    '4':'$100,000 - $200,000',
                    '5':'More than $200,000',
                },
                netWorthList:{
                    '1':'0 - $50,000',
                    '2':'$50,000 - $100,000',
                    '3':'$100,000 - $300,000',
                    '4':'More than $300,000',
                },
                sources_fund_list:{
                    '1':'Employment',
                    '2':'Inheritance',
                    '3':'Investment',
                    '4':'Real Estate',
                    '5':'Savings',
                    '6':'Other',
                },
                occupationList:{
                    '1':'Accountancy',
                    '2':'Admin/Secretarial',
                    '3':'Auctions',
                    '4':'Catering/Hospitality',
                    '5':'Creative/Media',
                    '6':'Education',
                    '7':'EFTs',
                    '8':'Emergency Services',
                    '9':'Engineering',
                    '10':'Financial Services',
                    '11':'Gas/Petrol',
                    '12':'Health/Medicine',
                    '13':'Army/Army Industry',
                    '14':'HR',
                    '15':'Insurance',
                    '16':'Gift cards',
                    '17':'Legal',
                    '18':'Leisure/Tourism',
                    '19':'Manufacturing',
                    '20':'Marketing/PR/Advertising',
                    '21':'Pharmaceuticals',
                    '22':'Precious metals/Diamonds',
                    '23':'Prepaid cards',
                    '24':'Private Investment Institutions',
                    '25':'Private banking',
                    '26':'Property Construction/Real Estate',
                    '27':'Retail',
                    '28':'Sales',
                    '29':'Social Care/Services',
                    '30':'Telecommunications',
                    '31':'Transport/Logistics',
                    '32':'Trust/Charities/Foundations',
                    '33':'Virtual Currency',
                    '34':'Other (Please specify)',
                },
                noTinReasons:{
                    '1':'The country/jurisdiction where the Account Holder is resident does not issue TINs to its residents',
                    '2':'The Account Holder is otherwise unable to obtain a TIN or equivalent number',
                    '3':'No TIN is required',
                },
                yesNo:{
                    1:'Yes',
                    0:'NO',
                }
            };
        },
        components: { Form, Field, ErrorMessage, },
        computed:{
            isdisabled() {
                return parseInt(this.store.user.step || 0) >= 2;
            }
        },
        methods: {
            submitQuestion(){
                if(this.form.isFATCA == '1'){
                    this.showFatca = true;
                    return
                }
                let data = {
                    "yearly_income"     : this.form.annual_income.toString(),
                    "net_worth"         : this.form.net_worth.toString(),
                    "occupation"        : (this.form.occupation == '34'?this.form.other_occupation:this.form.occupation.toString()),
                    "source_of_fund"    : (this.form.sources_fund == '6'?this.form.other_sources_of_funds:this.form.sources_fund.toString()),
                    "us_fatca"          : this.form.isFATCA.toString(),
                    "tax_residency"     : (this.form.isFATCA == '0'?this.form.tax_residence.toString():''),
                    "is_crs"            : this.form.isTin.toString(),
                    "crs"               : (this.form.isFATCA == '0' && this.form.isTin?this.form.tin_no.toString():''),
                    "crs_reason"        : (this.form.isFATCA == '0' && this.form.isTin == '0'?this.form.no_tin_reason.toString():''),/* reason dropdown */
                    "crs_reason_detail" : (this.form.isFATCA == '0' && this.form.isTin == '0'?this.form.reason.toString():''),/* reason Text */
                    "step"              : "2",
                    /*"ip_country"        : "",*/
                    "emp_status"        : "1",
                    "account_turnover"  : "1",
                }
                this.store.setQuestionsDetails(data,true).then(()=>{
                    // console.log(res);
                    this.changeStep(3)
                }).catch(e=>{console.log(e);})
            },
            getDetails(){
                this.store.getQuestionsDetails({},true).then(res=>{
                    let data = (res[0] || {}).profile || {}
                    this.form.annual_income   =   data.yearly_income || '';
                    this.form.net_worth       =   data.net_worth || '';
                    this.form.occupation      =   data.occupation?(this.occupationList[data.occupation]?data.occupation:'34'):'';
                    if(data.occupation && !this.occupationList[data.occupation]){
                        this.form.other_occupation = data.occupation
                    }
                    this.form.sources_fund    =   data.source_of_fund?(this.sources_fund_list[data.source_of_fund]?data.source_of_fund:'6'):'';
                    if(data.source_of_fund && !this.sources_fund_list[data.source_of_fund]){
                        this.form.other_sources_of_funds = data.source_of_fund
                    }
                    this.form.isFATCA         =   [0,1].includes(data.us_fatca)?data.us_fatca:'';
                    this.form.tax_residence   =   (this.form.isFATCA == '0'?data.tax_residency:'');
                    this.form.tin_no          =   (this.form.isFATCA == '0'?data.CRSNUMBER:'');
                    this.form.no_tin_reason   =   (this.form.isFATCA == '0'?data.CRSREASON:'');/* reason dropdown */
                    this.form.reason          =   (this.form.isFATCA == '0'?data.CRSREASONDETAIL:'');/* reason Text */
                    this.form.isTin           =   (this.form.isFATCA == '0'?(data.CRSNUMBER?1:0):'');
                    // console.log(res)
                }).catch(e=>console.log(e))
            }
        },
        created(){
            this.getDetails()
        }
    };
</script>
